var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorLayout',[_c('p',[_vm._v("退会済みの為、ご利用いただけません。")]),_c('p',[_vm._v("購入済のデジタルチケットやデジタルクーポンをご利用したい場合は下記よりご利用ください。")]),_c('a',{attrs:{"href":_vm.mypageUrl}},[_vm._v(_vm._s(_vm.mypageUrl))])])
}
var staticRenderFns = []

export { render, staticRenderFns }